import { useEditorSelector } from '@candulabs/craft';
import { UndoIcon, color, GlitterGray, Darker, OnyxGray, Lighter, Lighter2 } from 'canoe';
import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'styleguide';

import { useEventing } from 'commons/eventing';
import { TooltipBodyWithShortcuts } from 'craft/components/TooltipBodyWithShortcuts';
import { useEditor } from 'craft/hooks';

const HistoryContainer = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: row;
`;

const HistoryButton = styled.button`
  appearance: none;
  outline: none;
  flex-grow: 0;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${color(GlitterGray, Darker)};
  cursor: pointer;
  border: none;

  svg path {
    fill: ${color(OnyxGray, Lighter)};
  }

  &:disabled {
    cursor: not-allowed;
    background: ${color(GlitterGray, Lighter2)};
    svg path {
      fill: ${color(GlitterGray, Darker)};
    }
  }

  &:hover:not(:disabled) {
    background: ${color(GlitterGray)};
  }

  &:focus {
    outline: none;
  }
`;

const RedoIcon = styled(UndoIcon)`
  transform: scaleX(-1);
`;

export const HistoryActions = () => {
  const { actions } = useEditor();
  const { track } = useEventing();
  const { canUndo, canRedo } = useEditorSelector((_, query) => ({
    canUndo: query.canUndo(),
    canRedo: query.canRedo(),
  }));

  return (
    <HistoryContainer>
      <Tooltip
        position="top"
        content={<TooltipBodyWithShortcuts content="Undo" shortcuts={['mod', 'Z']} />}
      >
        <HistoryButton
          onClick={() => {
            actions.undo();
            track('editor.click.undo', { category: 'footer' });
          }}
          disabled={!canUndo}
        >
          <UndoIcon />
        </HistoryButton>
      </Tooltip>

      <Tooltip
        position="top"
        content={<TooltipBodyWithShortcuts content="Redo" shortcuts={['mod', 'Y']} />}
      >
        <HistoryButton
          onClick={() => {
            actions.redo();
            track('editor.click.redo', { category: 'footer' });
          }}
          disabled={!canRedo}
        >
          <RedoIcon />
        </HistoryButton>
      </Tooltip>
    </HistoryContainer>
  );
};
